const LOCAL_URL = process.env.REACT_APP_LOCAL_URL;
// const LOCAL_URL = "http://localhost:3000/"; 
export const API_URL = LOCAL_URL ? LOCAL_URL : window.location.origin + "/";
export const token_string = "IDPATSN";
export const API_TOKEN_PREFIX = "IDPAT";
export const CSRF_COOKIE_PREFIX = "IDPCC";
export const CSRF_HEADER_PREFIX = "IDPCH";
export const CSRF_TOKEN_PREFIX = "IDPCT";
export const ASSETS_URL = LOCAL_URL;
export const BASE_URL = window.location.origin + "/";
// if (process.env.NODE_ENV == 'development') {
//   // public/testdata/
//   console.log('LOCAL_URL', process.env.NODE_ENV);
//   console.log('API_URL', API_URL);
//   var _EXT = '.json';
//   var _post_meth = 'get';
// } else {
var _post_meth = "post";
var _EXT = "";
// }
export const EXT = _EXT;
export const _post = _post_meth;
export let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    // csrf_header: csrf_value,
};
export const frontEndModuleName = "front_end";
export const bulkEnrollModuleName = "bulk_enrollment";
export const commonModuleName = "common";

export const availableLanguages = [
    { label: "English", value: "en" },
    { label: "French", value: "fr" },
];

export const langShortLabels = {
    "en": "Eng",
    "fr": "Fre"
}

export const authToken =
    "mykademy mykademy:NzN07J7INMN6N-NGN0NjNb74N.7472NQ7HNF7k7R7R7u7271NWN_7fNcNQ7_N-N.75NLN7NbN3Ns7ONo7d7QNcNXN67v7HNGNJNv7kNoNm7uNRNcNgNJNQ717RNiNe7I7Q7U6261303736653535313835323734653139373132623565366431363737343533jMNMNgNONhN0NCNCNv7ZNj79ND7Y70jWN.jTNYNLN3N_NuNONjN-7wNHjCN3jCjA7JNi7aNHjAjXNQNlNJN_NlN9joNg7tNsNoj3NfjPNYNvjMNBjTNsjw7~7tjhNfNaN8N_NPjoN_NHNhNpNCjcjoNyjhN_jLN2N9jpNYjYNpNCNLNuNO70NTN87kNeNJ7xN.Ns7~NA7lNiNiNE7UNG7H7-NPNXNQ787rNhjLjoNtjWNaNtjzNyjhjtj.N1NtjmNaNlNqNsNZNM7r7ONGjsj3jpjVN.N~NiNJNKNPj67kjTN67C737tNQNRjNj_N_Nkj3NVjpjC7JNg7aNHjMjVNONANtN3jjjNjgNw7UjNjoj3NRjqN8Nwj3NfjPjpjtNSNCj7N4N2NTNtjNjTNMNdNDjDj.j8NM7175N.jsNuNwjpNtNp7f7CNwNvNfNdjejpNY7Hja";
export const accessToken =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjMiLCJuYW1lIjoiQ2FydCBGbG93IiwiZW1haWxfaWQiOiJkaXBpbi5zdXJlc2grY2FydEBteWthZGVteS5jb20iLCJtb2JpbGUiOiIxMjM0NTY3ODkwIiwidXNfbmFtZSI6IkNhcnQgRmxvdyIsInVzX2VtYWlsIjoiZGlwaW4uc3VyZXNoK2NhcnRAbXlrYWRlbXkuY29tIiwidXNfcGhvbmUiOiIxMjM0NTY3ODkwIiwidXNfZ29vZ2xlX2lkIjoiIiwidXNfZmFjZWJvb2tfaWQiOiIiLCJ1c191dWlkIjoiNjQzZDM1NzlhNGFiMiIsImluc3RpdHV0ZV9pZCI6IjEiLCJhY2NvdW50X2lkIjoiMjIxNTEiLCJ1c19hY2NvdW50X2lkIjoiMjIxNTEiLCJleHAiOjI0NzIwOTc5MDl9.wAdI1w3ORZdgU6blTGah-r9uBtvLWOpHmM9RYNFyLRA";

export const regularExpressions = {
    email: /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,6}$/,
    phone_code: /^\+?[0-9]{1,3}$/,
    phone: /^[0-9]{5,18}$/,
    phone_with_optional_code: /^(\+[0-9]{1,3})?[0-9]{5,18}$/, // here country code is optional
    phone_with_mandatory_code: /^\+[0-9]{5,21}$/, // here country code is mandatory,
    name: /^[a-zA-Z\.0-9_ \-]+$/ // alphanumeric, hyphen, underscore, dot and whitespaces only allow
}